module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运维公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择运维公司"
    },
    model: {
      value: (_vm.filters.operationcompanyId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "operationcompanyId", $$v)
      },
      expression: "filters.operationcompanyId"
    }
  }, _vm._l((_vm.operationcompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号规格"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入型号规格"
    },
    model: {
      value: (_vm.filters.modelname),
      callback: function($$v) {
        _vm.$set(_vm.filters, "modelname", $$v)
      },
      expression: "filters.modelname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "制造厂商"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入制造厂商"
    },
    model: {
      value: (_vm.filters.manufacturer),
      callback: function($$v) {
        _vm.$set(_vm.filters, "manufacturer", $$v)
      },
      expression: "filters.manufacturer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "准确度等级"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入准确度等级"
    },
    model: {
      value: (_vm.filters.accuracylevel),
      callback: function($$v) {
        _vm.$set(_vm.filters, "accuracylevel", $$v)
      },
      expression: "filters.accuracylevel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.filters.calibrationdate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "calibrationdate", $$v)
      },
      expression: "filters.calibrationdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": "",
      "ResetButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.DeviceCailss,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationcompanyName",
      "label": "所属公司"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "meteringutensil",
      "label": "计量器具名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "manufacturer",
      "label": "制造厂商"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "calibrationdate",
      "label": "校准日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "validuntil",
      "label": "有效期至"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "校准证书"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "30px",
            "height": "16px"
          },
          attrs: {
            "src": "/static/query.png",
            "preview-src-list": scope.row.calibrationSrcList
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合格证书"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "30px",
            "height": "16px"
          },
          attrs: {
            "src": "/static/query.png",
            "preview-src-list": scope.row.certificateSrcList
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), (_vm.usertype == 0) ? _c('table-delete-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.type,
      "visible": _vm.formVisible,
      "close-on-click-modal": false,
      "top": "5vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formDeviceCails",
    attrs: {
      "model": _vm.formDeviceCails,
      "label-width": "120px",
      "rules": _vm.formRules,
      "inline": true,
      "id": "formDeviceCails",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属公司",
      "prop": "operationcompanyId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属公司"
    },
    model: {
      value: (_vm.formDeviceCails.operationcompanyId),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "operationcompanyId", $$v)
      },
      expression: "formDeviceCails.operationcompanyId"
    }
  }, _vm._l((_vm.operationcompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证书号",
      "prop": "certificateno"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.certificateno),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "certificateno", $$v)
      },
      expression: "formDeviceCails.certificateno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计量器具名称",
      "prop": "meteringutensil"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.meteringutensil),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "meteringutensil", $$v)
      },
      expression: "formDeviceCails.meteringutensil"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号规格",
      "prop": "modelname"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.modelname),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "modelname", $$v)
      },
      expression: "formDeviceCails.modelname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "制造厂商",
      "prop": "manufacturer"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.manufacturer),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "manufacturer", $$v)
      },
      expression: "formDeviceCails.manufacturer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生产编号",
      "prop": "factorynumber"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.factorynumber),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "factorynumber", $$v)
      },
      expression: "formDeviceCails.factorynumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "准确度等级",
      "prop": "accuracylevel"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.accuracylevel),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "accuracylevel", $$v)
      },
      expression: "formDeviceCails.accuracylevel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验员",
      "prop": "inspector"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.inspector),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "inspector", $$v)
      },
      expression: "formDeviceCails.inspector"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出厂日期",
      "prop": "exfactory"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formDeviceCails.exfactory),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "exfactory", $$v)
      },
      expression: "formDeviceCails.exfactory"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主管",
      "prop": "director"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.director),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "director", $$v)
      },
      expression: "formDeviceCails.director"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校验",
      "prop": "checks"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.checks),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "checks", $$v)
      },
      expression: "formDeviceCails.checks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准",
      "prop": "calibration"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.calibration),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "calibration", $$v)
      },
      expression: "formDeviceCails.calibration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准日期",
      "prop": "calibrationdate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formDeviceCails.calibrationdate),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "calibrationdate", $$v)
      },
      expression: "formDeviceCails.calibrationdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期至",
      "prop": "validuntil"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formDeviceCails.validuntil),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "validuntil", $$v)
      },
      expression: "formDeviceCails.validuntil"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司地址",
      "prop": "companyaddress"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.companyaddress),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "companyaddress", $$v)
      },
      expression: "formDeviceCails.companyaddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮编",
      "prop": "postalcode"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.postalcode),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "postalcode", $$v)
      },
      expression: "formDeviceCails.postalcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.telephone),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "telephone", $$v)
      },
      expression: "formDeviceCails.telephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "传真",
      "prop": "fax"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.fax),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "fax", $$v)
      },
      expression: "formDeviceCails.fax"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网址",
      "prop": "website"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formDeviceCails.website),
      callback: function($$v) {
        _vm.$set(_vm.formDeviceCails, "website", $$v)
      },
      expression: "formDeviceCails.website"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "calibrationimage",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "校准证书图片",
      "prop": "calibrationimage",
      "id": "calibrationimage"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "http-request": _vm.httpRequest,
      "name": "file",
      "on-change": _vm.changeCalibration,
      "on-remove": _vm.removeCalibration,
      "accept": "image/*",
      "file-list": _vm.fileListShowCalibration,
      "list-type": "picture",
      "multiple": "",
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，且最好不超过500kb")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "calibrationimage",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "合格证书图片",
      "prop": "certificateimage",
      "id": "certificateimage"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "http-request": _vm.httpRequest,
      "name": "file",
      "on-change": _vm.changeCertificate,
      "on-remove": _vm.removeCertificate,
      "accept": "image/*",
      "file-list": _vm.fileListShowCertificate,
      "list-type": "picture",
      "multiple": "",
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，且最好不超过500kb")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-63e6833b"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/DeviceCalibration.vue
// module id = 1933
// module chunks = 1